import styled from "styled-components/macro";
import { Card } from "../StyledComponents/Card/Card";

export const Container = styled(Card)`
  border: solid 1px #e5e5e5;
  margin-top: 5px;
  max-width: 720px;
  padding: 20px;
`;

export const HeaderContainer = styled(Card)`
  border: solid 1px #e5e5e5;
  margin-top: 20px;
  max-width: 720px;
  padding: 25px;
`;

export const ListElement = styled.div`
  border-bottom: solid 1px #e5e5e5;
  max-width: 100%;
  padding: 20px;
  text-align: left;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #e6e6e6;
  }
`;

export const ListElementHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 0.9rem;
`;

export const ListElementBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.9rem;
`;

export const ListElementBodyLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: normal;
`;

export const ListElementBodyRight = styled.div`
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export const NoResultsContainer = styled.div`
  padding-top: 40px;
  padding-bottom: 50px;
  max-width: 720px;
`;

export const FlexEndWrapper = styled.div<{ isMatch: boolean }>`
  display: flex;
  justify-content: flex-end;
  ::before {
    ${(props) =>
      props.isMatch
        ? undefined
        : `
        content: "";
        border-top: 1px solid #ccc;
        margin-top: -1px;
        width: 279px;
        display: block;
        position: absolute;
    `}
  }
`;

export const CollapseButton = styled.button`
  border: none;
  font-size: 2em;
  color: ${({ theme }) => theme.primaryTextColor};
  background: none;
  font-weight: bold;
  cursor: pointer;
`;

export const HeaderText = styled.div`
  color: #021660;
  align-items: center;
  display: flex;
  width: 93%;

  h1 {
    margin-left: 10px;
    font-size: 20px;

    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const CollapseDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
`;

export const CollapsedTextDiv = styled.div`
  font-size: 14px;
  color: #4d5051;
  font-weight: normal;
`;

export const WorkflowStatusDropdownWrapper = styled.div`
  width: 150px;
  text-align: right;
  float: right;
`;
